import httpUtils from '@/utils/http-utils';
import i18n from '@/plugins/vue-i18n';

const baseRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}/blogs`,
  requesterType: 'CMS_WEB_SERVICE',
};
const blogApiReqNotification = httpUtils.createRequester(baseRequesterOptions);
const blogApiReqErrorHandling = httpUtils.createRequester(baseRequesterOptions, 'errorHandling');

const getRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return blogApiReqErrorHandling;
  }

  return blogApiReqNotification;
};

class BlogApi {
  fetchBlogs(filters = {}, errorManagementType) {
    return getRequester(errorManagementType)
      .get('/elastic', {
        headers: {
          'accept-language': i18n.locale,
        },
        params: {
          page: filters.page,
          size: filters.size,
          type: filters.types,
          a: filters.themes,
          // u: filters.authors,
          t: filters.text,
          // c: filters.countries,
          // r: filters.regions,
          sortByDate: filters.sortByDate,
          product: filters.product,
          provider: filters.provider,
          productId: filters.productId,
          providerId: filters.providerId,
        },
      }).then(res => res && res.data);
  }

  fetchBlog(id, idType, errorManagementType) {
    return getRequester(errorManagementType)
      .get(`/${id}`, {
        headers: {
          'accept-language': i18n.locale,
        },
        params: {
          idType,
        },
      }).then(res => res && res.data);
  }
}

export default new BlogApi();
